/**
 * InfoPanel Component
 *
 * Displays development environment information including
 * environment type, API URL, and organization count.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {
    FiInfo,
    FiServer,
    FiGlobe,
    FiUsers
} from 'react-icons/fi';

const InfoPanel = ({ organizationsCount }) => {
    return (
        <div className="dos-info-panel">
            <h4 className="dos-info-title">
                <FiInfo className="dos-info-icon" />
                Development Mode Active
            </h4>
            <p className="dos-info-text">
                This panel allows you to switch between different organization contexts for testing multi-tenant functionality.
                Switching will log you out and redirect to the login page with the new context.
            </p>
            <div className="dos-info-stats">
                <div className="dos-stat">
                    <FiServer className="dos-stat-icon" />
                    <span>Environment: Development</span>
                </div>
                <div className="dos-stat">
                    <FiGlobe className="dos-stat-icon" />
                    <span>API: {process.env.REACT_APP_API_URL || 'localhost:5050'}</span>
                </div>
                <div className="dos-stat">
                    <FiUsers className="dos-stat-icon" />
                    <span>Organizations: {organizationsCount}</span>
                </div>
            </div>
        </div>
    );
};

InfoPanel.propTypes = {
    organizationsCount: PropTypes.number.isRequired
};

export default InfoPanel;
